export default "__VITE_ASSET__t84DIDeo__"